var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionLine = function SvgQuestionLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 17.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m0-1.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12m-.75-3.75h1.5v1.5h-1.5zm1.5-1.234v.484h-1.5v-1.125a.75.75 0 0 1 .75-.75A1.125 1.125 0 1 0 8.897 8.28l-1.472-.295a2.626 2.626 0 1 1 3.325 3.031"
  })));
};
export default SvgQuestionLine;